/** The booking photo itself, with the 16:9 corner tag. */
export function PhotoFilledFrame({ src, venueName }: { src: string; venueName: string }) {
  return (
    <>
      <img
        src={src}
        alt={`Booking photo for ${venueName}`}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          maxWidth: 'none',
          objectFit: 'cover',
          display: 'block',
        }}
      />
      <span
        style={{
          position: 'absolute',
          top: 7,
          right: 7,
          fontSize: 9,
          fontWeight: 700,
          letterSpacing: '.05em',
          padding: '2px 6px',
          borderRadius: 4,
          background: 'rgba(15,25,18,.6)',
          color: '#fff',
        }}
      >
        16:9
      </span>
    </>
  );
}
